export default __webpack_public_path__ + "static/media/product-overview-bg.55f399f3.webp";